<template>
  <v-container fluid class="pt-5">
    <base-material-card
      color="primary"
      icon="mdi-database-cog"
      inline
      class="px-5 py-4 ml-0"
      title="Versionamento de Bases"
      elevation="0"
    >
       <v-row class="mt-5">
        <v-col cols="12" sm="4">
          <v-btn 
            color="primary"
            @click="$router.push('/administracao/versionamento-bases/versoes-ativas')"
          >
            <v-icon class="mr-2">mdi-table-of-contents</v-icon>
            Definir versões ativas
          </v-btn>
        </v-col>
       </v-row>

      <v-row class="mt-2 mb-1" justify="space-between">
        <v-col cols="12" sm="6" lg="3">
          <v-select
            :items="companies"
            clearable
            class="pt-6"
            hide-details
            item-text="name"
            item-value="id"
            v-model="selectedCompany"
            label="Empresa"
          />
        </v-col>
        <v-col cols="12" md="auto">
          <div
            class="text-subtitle-1 font-weight-medium mb-2 grey--text body-2"
          >
            Competência
          </div>
          <div class="d-flex align-center">
            <input-month
              rules="min:7"
              :minMonth="'2023-01'"
              :selectedMonth="competenciaDe"
              @monthSelected="setCompetenciaDe"
              dense
              class="mr-4"
            />
            <span
              class="mx-3 grey--text body-2"
            >
              até
            </span>
            <input-month
              rules="min:7"
              :minMonth="'2023-01'"
              :selectedMonth="competenciaAte"
              @monthSelected="setCompetenciaAte"
              dense
            />
          </div>
        </v-col>
        <v-col cols="6" sm="4" lg="2">
          <v-text-field
            :value="versaoSelecionada"
            @blur="versaoSelecionada = $event.target.value"
            class="pt-6"
            label="Versão"
            single-line
            hide-details
            type="number"
            :min="0"
            prepend-icon="mdi-numeric-1-box-multiple-outline"
            clearable
          />
        </v-col>
      </v-row>
      
      <v-data-table
        class="mb-8"
        :headers="headers"
        :items="filteredItems"
        :search.sync="search"
        :mobile-breakpoint="750"
        :loading="loadingTable"
        :footer-props="{
          showFirstLastPage: true,
          showCurrentPage: true,
          itemsPerPageOptions: [5, 15, 50, 100, -1],
        }"
        no-data-text="Nenhum versionamento encontrado"
      >
      <template v-slot:top>
        <v-row class="mx-auto" justify="space-between">
          <v-col cols="6" sm="3">
            <v-text-field
              v-model="search"
              class="mt-0 pt-1"
              label="Pesquisa Geral"
              single-line
              hide-details
              prepend-icon="mdi-magnify"
              clearable
            />
          </v-col>
        </v-row>
      </template>

        <template v-slot:[`item.id`]="{ item }">
          {{ item.id | parseNumberToIntegerBR }}
        </template>
        <template v-slot:[`item.title`]="{ item }">
          <div v-if="editingTitleId === item.id">
            <v-row no-gutters>
              <v-col cols="auto">
                <v-text-field
                  v-model="newTitle"
                  dense
                  hide-details
                  class="mr-2"
                >
                  <template v-slot:append-outer>
                    <v-btn
                      color="success"
                      icon
                      small
                      @click="updateTitle(item.id)"
                    >
                      <v-icon small>mdi-check</v-icon>
                    </v-btn>
                    <v-btn
                      color="error"
                      icon
                      small
                      @click="editingTitleId = null"
                    >
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </div>
          <div v-else>
            {{ item.title || "-" }}
            <v-btn
              icon
              small
              @click="openEditTitleInput(item.id, item.title)"
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </div>
        </template>
        <template v-slot:[`item.user_name`]="{ item }">
          {{ item.user_name ? item.user_name : "Sistema" }}
        </template>
        <template v-slot:[`item.updated_at`]="{ item }">
          {{ item.updated_at | parseToDateTimeBR }}
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>

import dayjs from 'dayjs';

import IndgerVersionsService from '@/services/IndgerVersionsService';
import CompanyService from '@/services/CompanyService';

export default {
  name: "VersionamentoBasesIndex",
  components: {
    InputMonth: () => import("@/components/general/InputMonth.vue"),  
  },
  data: () => ({
    items: [],
    headers: [
      {
        text: 'Competência',
        value: 'data_month_text'
      },
      {
        text: 'Versão',
        value: 'version_text'
      },
      {
        text: 'Empresa',
        value: 'company_name'
      },
      {
        text: 'Título',
        value: 'title'
      },
      {
        text: 'Criado por',
        value: 'user_name'
      },
      {
        text: 'Atualizado em',
        value: 'updated_at'
      },
    ],
    search: "",
    companies: [],
    selectedCompany: null,
    competenciaDe: null,
    competenciaAte: null,
    versaoSelecionada: null,
    loadingTable: false,
    editingTitleId: null,
    newTitle: null,
  }),
  computed: {
    filteredItems() {
      let items = this.items;

      if (this.selectedCompany) {
        items = items.filter(item => item.company_id == this.selectedCompany);
      }

      return items;
    },
  },
  mounted() {
    this.getData();
    
    this.selectedCompany = this.$store.getters.getCompanyId;
  },
  methods: {
    setCompetenciaDe(month) {
      this.competenciaDe = month;
    },
    setCompetenciaAte(month) {
      this.competenciaAte = month;
    },
    async getData() {
      return Promise.all([
        this.getAllVersions(),
        this.getCompanies(),
      ])
        .catch(err => {
          this.$toast.error("Erro ao recuperar dados", "", {
            position: "topRight",
          });
          console.error(err);
        });
    },
    getAllVersions() {
      this.loadingTable = true;
      this.items = [];

      return IndgerVersionsService.getAllVersions(
        this.competenciaDe,
        this.competenciaAte,
        this.versaoSelecionada
      )
        .then(res => {
          this.items = res;
        })
        .catch(err => {
          throw err;
        })
        .finally(() => this.loadingTable = false);
    },
    getCompanies() {
      this.loadingTable = true;

      return CompanyService.getCompanies()
        .then(res => {
          this.companies = res;
        })
        .catch(err => {
          throw err;
        });
    },
    openEditTitleInput(id, title) {
      this.editingTitleId = id;
      this.newTitle = title;
    },
    updateTitle(id) {
      IndgerVersionsService.updateTitle(id, this.newTitle)
        .then(res => {
          this.editingTitleId = this.newTitle = null;
          
          this.getAllVersions();
          this.$toast.success("Título atualizado com sucesso.", "", {
            position: "topRight",
          });
        })
        .catch(err => {
          this.$toast.error("Erro as salvar título.", "", {
            position: "topRight",
          });
          throw err;
        });
    },
    parseMonth(date) {
      return dayjs(date).format('MM/YYYY');
    }
  },
  watch: {
    competenciaDe() {
      this.getAllVersions();
    },
    competenciaAte() {
      this.getAllVersions();
    },
    versaoSelecionada() {
      this.getAllVersions();
    },
  }
}

</script>

<style>

</style>